var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjRouteTabs"),
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "SettingBaseDataAfterSalesReason.table.code"
                          ),
                          prop: "reasonCode",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.reasonCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "reasonCode", $$v)
                            },
                            expression: "queryParams.reasonCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "SettingBaseDataAfterSalesReason.table.description"
                          ),
                          prop: "reasonDescribe",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.reasonDescribe,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "reasonDescribe", $$v)
                            },
                            expression: "queryParams.reasonDescribe",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("table.statusText"),
                          prop: "status",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: { "option-list": _vm.STATUS_ENABLED_NUM },
                          model: {
                            value: _vm.queryParams.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "status", $$v)
                            },
                            expression: "queryParams.status",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "SettingBaseDataAfterSalesReason.table.isUse"
                          ),
                          prop: "useFlag",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: { "option-list": _vm.USE_FLAG_NUM },
                          model: {
                            value: _vm.queryParams.useFlag,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "useFlag", $$v)
                            },
                            expression: "queryParams.useFlag",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName:
                              "v-permission:SettingBaseDataAfterSalesReasonRefundIndex_Add",
                            arg: "SettingBaseDataAfterSalesReasonRefundIndex_Add",
                          },
                        ],
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: { click: _vm.onAdd },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "SettingBaseDataAfterSalesReason.table.newAfterSales"
                            )
                          )
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "status"
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: scope.row.status
                                                ? "success"
                                                : "info",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.STATUS_ENABLED_NUM.bjGet(
                                                    scope.row.status
                                                  )
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : col.prop === "useFlag"
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: scope.row.useFlag
                                                ? "success"
                                                : "info",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.USE_FLAG_NUM.bjGet(
                                                    scope.row.useFlag
                                                  )
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permission",
                                            rawName:
                                              "v-permission:SettingBaseDataAfterSalesReasonRefundIndex_Edit",
                                            arg: "SettingBaseDataAfterSalesReasonRefundIndex_Edit",
                                          },
                                        ],
                                        staticClass: "edit-btn",
                                        attrs: {
                                          disabled: !!props.row.useFlag,
                                          type: "text",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEdit(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("editText")))]
                                    ),
                                    props.row.status
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "permission",
                                                rawName:
                                                  "v-permission:SettingBaseDataAfterSalesReasonRefundIndex_Status",
                                                arg: "SettingBaseDataAfterSalesReasonRefundIndex_Status",
                                              },
                                            ],
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onStatus(
                                                  0,
                                                  props.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("disableText"))
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    !props.row.status
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "permission",
                                                rawName:
                                                  "v-permission:SettingBaseDataAfterSalesReasonRefundIndex_Status",
                                                arg: "SettingBaseDataAfterSalesReasonRefundIndex_Status",
                                              },
                                            ],
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onStatus(
                                                  1,
                                                  props.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("enableText")))]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permission",
                                            rawName:
                                              "v-permission:SettingBaseDataAfterSalesReasonRefundIndex_Delete",
                                            arg: "SettingBaseDataAfterSalesReasonRefundIndex_Delete",
                                          },
                                        ],
                                        staticClass: "delete-btn",
                                        attrs: {
                                          disabled: !!props.row.useFlag,
                                          type: "text",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDelete(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("delText")))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("DataForm", {
        ref: "DataForm",
        on: { reFresh: _vm.reFresh, batchDeleteApi: _vm.batchDeleteApi },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }